import React from "react";
import { Skeleton, SkeletonProps, SxProps, Theme } from "@mui/material";

export type WcSkeletonProps = SkeletonProps & {
  sx?: SxProps<Theme>;
};

export const WcSkeleton = (props: WcSkeletonProps) => <Skeleton sx={props.sx} {...props} />;

export default WcSkeleton;
